import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("ct_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const fileUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("/api")) return `${BACKEND}${u}`;
  return u;
};

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
}

export default api;
